import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useCompleteDataTransQRM } from 'featureSliced/shared/hooks/useCompleteDataTransQRM'
import { useCompleteSaferPayQRM } from 'featureSliced/shared/hooks/useCompleteSaferPayQRM'
import { useCompleteAdyen } from 'featureSliced/shared/hooks/useCompleteAdyen'

export const QRMConfirmation = () => {
  // Hooks
  const [searchParams] = useSearchParams()
  const isAppInit = useMySelector((state) => state.app.isAppInit)
  const completeAdyen = useCompleteAdyen()
  const completeSaferPay = useCompleteSaferPayQRM()
  const completeDataTrans = useCompleteDataTransQRM()

  // vars
  const datatransTrxId = searchParams.get('datatransTrxId')
  const saferPayOrderGuid = searchParams.get('orderGuid')
  const pKey = searchParams.get('pKey')
  // const redirectResult = searchParams.get('redirectResult')

  // useEffect
  useEffect(() => {
    if (datatransTrxId && !saferPayOrderGuid && !pKey && isAppInit) {
      completeDataTrans()
    }
  }, [isAppInit, datatransTrxId, saferPayOrderGuid])

  useEffect(() => {
    if (!datatransTrxId && saferPayOrderGuid && !pKey && isAppInit) {
      completeSaferPay()
    }
  }, [isAppInit, datatransTrxId, saferPayOrderGuid])

  useEffect(() => {
    if (!datatransTrxId && !saferPayOrderGuid && pKey && isAppInit) {
      completeAdyen()
    }
  }, [isAppInit, datatransTrxId, saferPayOrderGuid])

  return null
}
